import React from 'react';
import { Card, Button, Space, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;

interface PlaceholderProps {
  title: string;
  description?: string;
}

const Placeholder: React.FC<PlaceholderProps> = ({ title, description }) => {
  const navigate = useNavigate();

  return (
    
      <Card style={{ textAlign: 'center', padding: '60px 20px', minHeight: 'calc(100vh - 200px)' }}>
        <Title level={2}>{title}</Title>
        {description && <Paragraph>{description}</Paragraph>}
        <Paragraph type="secondary" style={{ marginTop: 24 }}>
          Эта страница находится в разработке
        </Paragraph>
        <Space style={{ marginTop: 32 }}>
          <Button 
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate('/dashboard')}
          >
            Вернуться на главную
          </Button>
        </Space>
      </Card>
    
  );
};

export default Placeholder;

